import { useTranslation } from 'react-i18next';

import { Layout, OrganizationDevices } from '../../../components/app';
import { Button } from '../../../components/common';
import { ModalName } from '../../../enums';
import { useOpenModal } from '../../../features/modals';
import { useFetchOrganizationDevices } from '../../../features/organization';

export const OrganizationDevicesPage = () => {
  const { t } = useTranslation();
  const openAddDevicesModal = useOpenModal(ModalName.ADD_DEVICES);
  const openOrderDevicesModal = useOpenModal(ModalName.ORDER_DEVICES);

  useFetchOrganizationDevices();

  return (
    <Layout
      backButton={{ title: t('organization.title.organization'), path: '/app/organization' }}
      rightButtons={[
        <Button
          key="add"
          text={t('organization.devices.button.addDevices')}
          size="sm"
          onClick={() => openAddDevicesModal()}
        />,
        <Button
          key="order"
          text={t('organization.devices.button.orderDevices')}
          type="secondary"
          size="sm"
          onClick={() => openOrderDevicesModal()}
        />,
      ]}
    >
      <OrganizationDevices expanded={true} />
    </Layout>
  );
};
